export const blockIconsUiactionsMenuNew = (
	<span className='material-symbols-outlined'>menu</span>
);
